import { useMutation, useQueryClient } from "react-query";
import { api } from "utils/api";
import { artistKeys } from "./queryKeys";

/* Temporary End Point to Convert Artist Collections */

const convertGallery = (artistId?: string) =>
  api.post(`/gallery/artists/convert`, {
    body: JSON.stringify({ artistId }),
  });

const useGalleryConvert = (artistId?: string) => {
  const queryClient = useQueryClient();
  return useMutation(
    `gallery-convert-${artistId}`,
    () => convertGallery(artistId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["gallery"]);
        queryClient.invalidateQueries(artistKeys.detail(artistId));
      },
    },
  );
};

export { useGalleryConvert };
